// extracted by mini-css-extract-plugin
export var wrapper = "index-module--wrapper--CQrLZ";
export var fadein = "index-module--fadein--Tv3fs";